import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { resolve } from './helpers';
import { Destination } from './types';

type Props<T extends string> = {
  to: Destination<T>;
  /**
   * Replace current route with next one; defaults to `true` which prevents a
   * loop where pressing back takes you to the page that redirected you,
   * redirecting you forward again.
   */
  replace?: boolean;
};

export function createRedirect<RoutePath extends string>() {
  const Redirect = <T extends RoutePath>(props: Props<T>) => {
    let { to, replace = true } = props;
    let history = useHistory();
    useEffect(() => {
      let path = to[0];
      let params = to[1] || {};
      let resolvedPath = resolve(path, params);
      if (replace) {
        history.replace(resolvedPath);
      } else {
        history.push(resolvedPath);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
  };
  return Redirect;
}
